// roleRoutes.ts
export const roleRoutes: Record<string, string[]> = {
  "SUPER ADMIN": [
    "/forms",
    "/roles",
    "/stations",
    "/centers",
    "/users",
    "/slots",
    "/release-appointment",
    "/add-stations",
    "/edit-appointment",
    "/edit-log",
    "/center-dashboard",
    "/fee-tax",
    "/coupons",
    "/refund",
    '/parent-list',
    '/notification-templet',
    '/helpdesk',
    '/questionnaire',
    '/histories',
    '/emr-management',
  ],

  "CENTER ADMIN": [
    "/new-dashboard",
    "/welcome_screen",
    "/check-view",
    "/growth-chart",
    "/lab-pickup",
    "/lab-reports-entry",
    "/bnu-sample",
    "/nurse-page",
  ],

  "NURSE1": [
    "/nurse-1/dashboard",
    "/nurse-1",   
  ],
  "NURSE2": [
    "/nurse-2/dashboard", 
    "/nurse-2",  
  ],
  "NURSE3": [
    "/nurse-3/dashboard",
    "/nurse-3",   
  ],
  "OPTOMETRY": [
    "/optometrist/dashboard", 
    "/vision-screening",  
  ],
  "AUDIOLOGY": [
    "/audiology/dashboard", 
    "/audiology/screening",  
  ]
};
